var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.2695 48.2878C96.2695 21.7754 74.7819 0.287842 48.2695 0.287842C21.7571 0.287842 0.269531 21.7754 0.269531 48.2878C0.269531 72.2504 17.8195 92.1066 40.7695 95.7066V62.1628H28.5819V48.2878H40.7695V37.7128C40.7695 25.6846 47.9321 19.0378 58.9007 19.0378C64.1507 19.0378 69.6445 19.9753 69.6445 19.9753V31.7878H63.5883C57.6257 31.7878 55.7695 35.491 55.7695 39.2878V48.2878H69.0819L66.9539 62.1628H55.7695V95.7066C78.7195 92.1066 96.2695 72.2504 96.2695 48.2878Z",
    fill: "#1877F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.954 62.1628L69.082 48.2878H55.7696V39.2878C55.7696 35.491 57.6258 31.7878 63.5884 31.7878H69.6446V19.9753C69.6446 19.9753 64.1508 19.0378 58.9008 19.0378C47.9322 19.0378 40.7696 25.6846 40.7696 37.7128V48.2878H28.582V62.1628H40.7696V95.7066C43.2164 96.091 45.7196 96.2878 48.2696 96.2878C50.8196 96.2878 53.3228 96.091 55.7696 95.7066V62.1628H66.954Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8025e98500f529fc65f109420e7bb761.svg";
export { ForwardRef as ReactComponent };